<nav class="nav fixed-top p-3 justify-content-center"
style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <a class="nav-link" routerLink="/">Home</a>
    <a class="nav-link" routerLink="/aplikasi">Applikasi</a>
    <a class="nav-link" routerLink="/website">Website</a>
    <a class="nav-link" routerLink="/axcoraschool">ERP</a>
  </nav>

<div class="slider-area "
style="background-image: url('assets/img/h1_hero.png');
      background-repeat: no-repeat;
        background-attachment: fixed;
background-position: center; 
background-size: cover;
    "
    >
<div class="slider-active">


<div class="single-slider slider-height" >
<div class="container">
<div class="row justify-content-center">
<div class="col-xl-8 col-lg-11 col-md-12">
<div class="hero__caption text-center">
    <a routerLink="/"><img class="img-fluid" src="assets/img/logo.png" alt="axcora school"/></a>
    <h2><strong><a class="text-white" href="https://axcoraschool.vercel.app">Aplikasi sekolah Online</a></strong></h2>
    <img class="img-fluid" alt="aplikasi sekolah online" src="assets/img/aplikasisekolahapps.png"/>
    <p>Axcora school app technology special aplikasi sekolah online , pilih aplikasi anda dan mulai menggunakan untuk kebuutuhan edukasi.</p>
  
</div>
</div>
</div>
</div>
</div>
</div>
</div>    

    
    <div class="about-area2 section-padding40 section-bg2" data-background="assets/img/section-bg3.png">
    <div class="container">
    <div class="row align-items-center">
    <div class="col-xl-5 col-lg-6 col-md-12">
    <div class="about-caption mb-50">
    <div class="about-icon text-center text-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
            <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
          </svg>
    </div>
    
    <div class="section-tittle mb-25">
    <h2>E-Learning Premium.</h2>
    </div>
    <p class="mb-20">
        Applikasi belajar mengajar yang sangat lengkap dengan login guru apps, dan siswa apps, hingga kompleks nya kebutuhan untuk e-learning , ini adalah apps rekomendasi terbaik untuk digunakan.
    </p>
    <a routerLink="/belajar/premium" class="btn all-btn text-white">Informasi</a>
    </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9">
    
    <div class="about-img ">
    <img src="assets/img/aplikasisekolah online web app (9).jpg" alt="aplikasi belajar online sekolah lengkap"/>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    
    <div class="about-area2 pb-bottom">
    <div class="container">
    <div class="row align-items-center">
    <div class="col-xl-6 col-lg-5 col-md-9">
    
    <div class="about-img ">
    <img src="assets/img/aplikasisekolah online web app (2).jpg" alt="aplikasi belajar online dengan download upload media file tugas"/>
    </div>
    </div>
    <div class="col-xl-5 col-lg-6 col-md-12">
    <div class="about-caption mb-50">
        <div class="about-icon text-center text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
                <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
              </svg>
    </div>
    
    <div class="section-tittle mb-25">
    <h2>E-Lerning Media</h2>
    </div>
    <p class="mb-20">
System belajar mengajar dengan kemampuan nya dalam kebutuhan untuk upload dan download file tugas , plus latian atau ulangan secara online fitur tersedia pada apps ini.
    </p>
    <a routerLink="/belajar/media" class="btn all-btn text-white">Informasi</a>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    <div class="about-area2 section-padding40 section-bg2" data-background="assets/img/section-bg3.png">
        <div class="container">
        <div class="row align-items-center">
        <div class="col-xl-5 col-lg-6 col-md-12">
        <div class="about-caption mb-50">
        <div class="about-icon text-center text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
                <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
              </svg>
        </div>
        
        <div class="section-tittle mb-25">
        <h2>E-Learn simple.</h2>
        </div>
        <p class="mb-20">
            Simple untuk kebutuhan e-learning online dengan applikasi ini, sangat mudah digunakan memudahkan siswa dan guru dalam kebutuhan belajar mengajar dengan cepat dan simple.
        </p>
        <a routerLink="/belajar/simple" class="btn all-btn text-white">Informasi</a>
        </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9">
        
        <div class="about-img ">
        <img src="assets/img/aplikasisekolah online web app (8).jpg" alt="aplikasi belajar sekolah mudah digunakan"/>
        </div>
        </div>
        </div>
        </div>
        </div>
        
        
        <div class="about-area2 pb-bottom">
        <div class="container">
        <div class="row align-items-center">
        <div class="col-xl-6 col-lg-5 col-md-9">
        
        <div class="about-img ">
        <img src="assets/img/aplikasisekolah online web app (2).webp" alt="aplikasi nilai rapot sekolah online"/>
        </div>
        </div>
        <div class="col-xl-5 col-lg-6 col-md-12">
        <div class="about-caption mb-50">
            <div class="about-icon text-center text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
                    <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
                  </svg>
        </div>
        
        <div class="section-tittle mb-25">
        <h2>Rapot Online Apps</h2>
        </div>
        <p class="mb-20">
Semakin sempurna dengan rapot online , aplikasi penilaian ini benar benar membantu dalam kebutuhan untuk cek nilai rapot siswa secara include dengan proteksi password siswa.
        </p>
        <a routerLink="/rapot" class="btn all-btn text-white">Informasi</a>
        </div>
        </div>
        </div>
        </div>
        </div>

    <div class="about-area2 section-padding40 section-bg2" data-background="assets/img/section-bg3.png">
        <div class="container">
        <div class="row align-items-center">
        <div class="col-xl-5 col-lg-6 col-md-12">
        <div class="about-caption mb-50">
        <div class="about-icon text-center text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
                <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
              </svg>
        </div>
        
        <div class="section-tittle mb-25">
        <h2>Pembayaran Sekolah</h2>
        </div>
        <p class="mb-20">
            Hadir kini aplikasi untuk mencatat keuangan sekolah secara detail hingga kebutuhan untuk pembayaran pada lingkup sekolah .
        </p>
        <a routerLink="/pembayaran" class="btn all-btn text-white">Informasi</a>
        </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9">
        
        <div class="about-img ">
        <img src="assets/img/aplikasisekolah online web app (1).webp" alt="aplikasi pembayaran sekolah"/>
        </div>
        </div>
        </div>
        </div>
        </div>
        
        
        <div class="about-area2 pb-bottom">
        <div class="container">
        <div class="row align-items-center">
        <div class="col-xl-6 col-lg-5 col-md-9">
        
        <div class="about-img ">
        <img src="assets/img/aplikasisekolah online web app (20).jpg" alt="aplikasi absensi siswa sekolah"/>
        </div>
        </div>
        <div class="col-xl-5 col-lg-6 col-md-12">
        <div class="about-caption mb-50">
            <div class="about-icon text-center text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
                    <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
                  </svg>
        </div>
        
        <div class="section-tittle mb-25">
        <h2>Absensi Siswa</h2>
        </div>
        <p class="mb-20">
            Modern technology dalam kebutuhan untuk absensi siswa include dengan laporan detail nya memudahkan dalam kontrol dan monitoring kehadiran siswa.
        </p>
        <a routerLink="/absensi" class="btn all-btn text-white">Informasi</a>
        </div>
        </div>
        </div>
        </div>
        </div>

            <div class="about-area2 section-padding40 section-bg2" data-background="assets/img/section-bg3.png">
    <div class="container">
    <div class="row align-items-center">
    <div class="col-xl-5 col-lg-6 col-md-12">
    <div class="about-caption mb-50">
    <div class="about-icon text-center text-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
            <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
          </svg>
    </div>
    
    <div class="section-tittle mb-25">
    <h2>E-Learn Gratis.</h2>
    </div>
    <p class="mb-20">
Dapatkan aplikasi latihan tugas ini secara gratis setiap package website sekolah cms axcora school, dengan apps ini memudahkan dalam memberikan tugas kepada siswa include penilaian secara langsung.</p>
    <a routerLink="/belajar/gratis" class="btn all-btn text-white">Informasi</a>
    </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9">
    
    <div class="about-img ">
    <img src="assets/img/aplikasisekolah online web app (4).png" alt="aplikasi e-learn sekolah gratis download source code"/>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    
    
    <div class="about-area2 pb-bottom">
    <div class="container">
    <div class="row align-items-center">
    <div class="col-xl-6 col-lg-5 col-md-9">
    
    <div class="about-img ">
    <img src="assets/img/aplikasisekolah online web app (3).png" alt="aplikasi pembuatan website CMS sekolah gratis"/>
    </div>
    </div>
    <div class="col-xl-5 col-lg-6 col-md-12">
    <div class="about-caption mb-50">
        <div class="about-icon text-center text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
                <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
              </svg>
    </div>
    
    <div class="section-tittle mb-25">
    <h2>CMS Web Sekolah</h2>
    </div>
    <p class="mb-20">
Aplikasi pembuatan website sekolah yang secara skema sudah terstruktur memudahkan web admin sekolah dalam bekerja dan membuat website sekolah semakin cepat.
    </p>
    <a routerLink="/cms"class="btn all-btn text-white">Informasi</a>
    </div>
    </div>
    </div>
    </div>
    </div>

    <div class="testimonial-area fix" >

    
    
        <div class="wantToWork-area ">
        <div class="container">
        <div class="wants-wrapper w-padding2 section-bg2" 
         style="background-image: url('assets/img/section_bg02.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-9 col-md-8">
        <div class="wantToWork-caption text-center">
        <h2>ERP Sekolah</h2>
        <p>All in one system web app sekolah dalam satu applikasi super lengkap dalam kebutuhan proses belajar mengajar , e learning, absensi, hingga keuangan sekolah , agenda pengumuman berita sekolah include.
    <br/>
    Applikasi ERP sekolah dengan admin apps, guru pengajar apps, tata usaha dan keuangan apps, siswa murid apps, all in one integrasi dalam axcora school ERP untuk sekolah anda.
        </p>
        <a routerLink="/axcoraschool" class="btn3 wantToWork-btn">Pelajari ERP Sekolah</a><br/><br/><br/><br/>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
      </div>
